export default __webpack_public_path__ + "static/media/GHGSAT_LOGO_1200x630.166b0f63.webp";